import React, { useEffect } from "react";
import { Dropdown, Form } from "rsuite";
import { useSingleTrip } from "../../../hooks/useQuery/useTrips";
import { ShowPrice, getDate } from "../../tripDetail/views/bookingAndForms";

const DateDropdown = ({ id, onChange, dates }) => {
  const { isLoading, isError, error, data: TripData } = useSingleTrip(id);
  // console.log(TripData?.data, "TripData");
  const data = TripData?.data;
  // console.log(data, "dataaaaa");
  return (
    <div>
      {data?.departure_dates?.length && (
        <Form.Group>
          <style>
            {`
                  .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
      width: 100% !important;
    }
  `}
          </style>
          <Dropdown
            className="date-and-rates-dropdown"
            id="dropd"
            menuStyle={{
              overflowY: "scroll",
              width: "100%",
              maxHeight: 200,
              textAlign: "center",
            }}
            style={{ padding: "0.5rem 0", width: "100%" }}
            trigger={["click"]}
            title={
              dates
                ? `View Dates & Rates ${dates?.start_date} ~ ${dates?.end_date}`
                : "View Dates & Rates"
            }
          >
            {data?.departure_dates?.map((ele) => (
              <Dropdown.Item
                disabled={ele?.availability?.toLowerCase() === "not available"}
                onClick={() => {
                  if (ele?.availability?.toLowerCase() !== "not available") {
                    onChange("datesAndCities", {
                      ...ele,
                      arrivalName: data?.arrival_cities[0]?.name,
                      departureName: data?.departure_cities[0]?.name,
                      arrival: data?.arrival_cities[0]?.id,
                      departure: data?.departure_cities[0]?.id,
                    });
                  }
                }}
              >
                {`${getDate(ele?.start_date).toLocaleDateString()} ~ ${getDate(
                  ele?.end_date
                ).toLocaleDateString()} ${
                  data?.currency ? data?.currency : "C$"
                } ${
                  ele?.discounting_member_price
                    ? ele?.discounting_member_price
                    : ele?.price
                }${data?.supplier?.slug == 'just-you'?"/SGL per person ":"/DBL per person "}`}{" "}
                {/* <>
                  <div>
                    {`${getDate(
                      ele?.start_date
                    ).toLocaleDateString()} ~ ${getDate(
                      ele?.end_date
                    ).toLocaleDateString()}`}
                  </div>
                  <ShowPrice priceInfo={ele} className={"primary--color"} />
                </> */}
              </Dropdown.Item>
            ))}
          </Dropdown>
        </Form.Group>
      )}
    </div>
  );
};

export default DateDropdown;
